export default __webpack_public_path__ + "static/media/section3-bg.d4df745a.png";